import { TextField, Typography } from "@mui/material";

import defaultStyles from "./styles";

interface StyledTextFieldProps {
  children?: React.ReactNode;
  styles?: object;
  label?: string | JSX.Element;
  required?: boolean;
  [rest: string]: any;
}

export default function StyledTextField({
  styles = {},
  label = "",
  required = false,
  ...rest
}: StyledTextFieldProps) {
  return (
    <>
      {label && (
        <Typography gutterBottom>
          {label} {required ? "*" : ""}
        </Typography>
      )}
      <TextField {...rest} sx={[defaultStyles.root, styles]} />
    </>
  );
}
